import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
//import PatientEvolution from './patient-evolution/index.vue';
const PatientEvolution = () => import('./patient-evolution/index.vue')

//import UsersReport from './users/index.vue';
const UsersReport = () => import('./users/index.vue')

//import UsedProductsReport from './used-products/index.vue';
const UsedProductsReport = () => import('./used-products/index.vue')

//import ClientUnitReport from './client-units/index.vue';
const ClientUnitReport = () => import('./client-units/index.vue')

const RulesReport = () => import('./rules/index.vue')

const AlertsPrescriptionsReport = () => import('./alerts-prescriptions/index.vue')

const ClientUnitsProductsReport = () => import('./client-units-products/index.vue')

const PrescriptorPrescriptionsReport = () => import('./prescriptor-prescriptions/index.vue')

const AddressPrescriptionsReport = () => import('./address-prescriptions/index.vue')

const PrescriptionsMonthPDFs = () => import('./prescriptions-month-pdfs/index.vue')


export const reportRoutes = [];


if (
    checkUserPermissions([
        PERMISSIONS_KEYS.PATIENT_EVOLUTION_REPORT
    ])
) {
    reportRoutes.push({
        path: '/relatorio/paciente/evolucao',
        name: 'Relatórios|Evolução do Paciente',
        component: PatientEvolution,
        meta: {
            icon: 'fa-file-invoice',
            requiresAuth: true,
        },
    });
}

if (
    checkUserPermissions([
        PERMISSIONS_KEYS.USED_PRODUCTS_REPORT
    ])
) {
    reportRoutes.push({
        path: '/relatorio/produtos/utilizados',
        name: 'Relatórios|Insumos Consumidos',
        component: UsedProductsReport,
        meta: {
            icon: 'fa-file-invoice',
            requiresAuth: true,
        },
    });
}

if (
    checkUserPermissions([
        PERMISSIONS_KEYS.USERS_REPORT
    ])
) {
    reportRoutes.push({
        path: '/relatorio/usuario',
        name: 'Relatórios|Cadastro de Usuários',
        component: UsersReport,
        meta: {
            icon: 'fa-file-invoice',
            requiresAuth: true,
        },
    });
}

if (
    checkUserPermissions([
        PERMISSIONS_KEYS.CLIENT_UNITS_REPORT
    ])
) {
    reportRoutes.push({
        path: '/relatorio/unidades-clientes',
        name: 'Relatórios|Cadastro de Unidades Cliente',
        component: ClientUnitReport,
        meta: {
            icon: 'fa-file-invoice',
            requiresAuth: true
        },
    });
}

if (
    checkUserPermissions([
        PERMISSIONS_KEYS.RULES_REPORT
    ])
) {
    reportRoutes.push({
        path: '/relatorio/regras',
        name: 'Relatórios|Cadastro de Regras',
        component: RulesReport,
        meta: {
            icon: 'fa-file-invoice',
            requiresAuth: true
        },
    });
}

if (
    checkUserPermissions([
        PERMISSIONS_KEYS.ALERTS_PRESCRIPTIONS_REPORT
    ])
) {
    reportRoutes.push({
        path: '/relatorio/regras/prescricoes',
        name: 'Relatórios|Utilização de Regras',
        component: AlertsPrescriptionsReport,
        meta: {
            icon: 'fa-file-invoice',
            requiresAuth: true,
        },
    });
}

if (
    checkUserPermissions([
        PERMISSIONS_KEYS.CLIENT_UNITS_PRODUCTS_REPORT
    ])
) {
    reportRoutes.push({
        path: '/relatorio/unidades/produtos',
        name: 'Relatórios|Produtos Unidade Cliente',
        component: ClientUnitsProductsReport,
        meta: {
            icon: 'fa-file-invoice',
            requiresAuth: true,
        },
    });
}

if (
    checkUserPermissions([
        PERMISSIONS_KEYS.PRESCRIPTOR_PRESCRIPTIONS_REPORT
    ])
) {
    reportRoutes.push({
        path: '/relatorio/prescricoes/prescritores',
        name: 'Relatórios|Prescrições por Prescritor',
        component: PrescriptorPrescriptionsReport,
        meta: {
            icon: 'fa-file-invoice',
            requiresAuth: true,
        },
    });
}

if (
    checkUserPermissions([
        PERMISSIONS_KEYS.ADDRESS_PRESCRIPTIONS_REPORT
    ])
) {
    reportRoutes.push({
        path: '/relatorio/prescricoes/enderecos',
        name: 'Relatórios|Prescrições por Endereço',
        component: AddressPrescriptionsReport,
        meta: {
            icon: 'fa-file-invoice',
            requiresAuth: true,
        },
    });
}

if (
    checkUserPermissions([
        PERMISSIONS_KEYS.PRESCRIPTIONS_MONTH_PDFS
    ])
) {
    reportRoutes.push({
        path: '/relatorio/prescricoes/pdfs/mes',
        name: 'Relatórios|PDFs - Prescrições do Mês',
        component: PrescriptionsMonthPDFs,
        meta: {
            icon: 'fa-file-invoice',
            requiresAuth: true,
        },
    });
}



